<div [class]="classes" [style]="{'--color': brandColor}">
  <span [ngClass]="{'invalid': control.invalid}"
        class="left-icon">{{leftIcon}}</span>
  <span *ngIf="!hidePlaceholder && customPlaceholder" class="ns-placeholder">{{ customPlaceholder }}</span>
  <input (input)="onType($event)"
         [formControl]="control"
         [maxLength]="maxLength"
         [max]="maxValue"
         [min]="minValue"
         [ngClass]="{'invalid': control.invalid}"
         [placeholder]="customPlaceholder ? '' : placeholder"
         type="number">
</div>
